import React, {useEffect} from "react";
import "./style.css";
import {Image} from "../../../../../components/Image";

export const MobileOtherBenefits = ({
    clickNext = () => {},
    clickPrev = () => {},
    clicked
                            }) => {
  return (
    <div className="other-benefits-mobile" data-model-id="16761:2188">

      <div className="div">
        <div className="title">
          <p className="heading">
            Healthy eating can help you achieve your goal and has other
            benefits:
          </p>
        </div>

        <div className="word">
          <div className="icon-and-text">
              <Image src={'/static/image/questionnaire/weight-loss/otherBenefits/Flexed biceps.png'} width={32} height={32} />
              <div className="text-wrapper">Reduced risk of diabetes</div>
          </div>

          <div className="icon-and-text-2">
              <Image src={'/static/image/questionnaire/weight-loss/otherBenefits/Anatomical heart.png'} width={32} height={32} />
                <div className="text-wrapper">Normal blood pressure</div>
          </div>

          <div className="icon-and-text-2">
              <Image src={'/static/image/questionnaire/weight-loss/otherBenefits/Leafy green.png'} width={32} height={32} />
              <div className="text-wrapper">Balanced cholesterol levels</div>
          </div>
        </div>
      </div>
    </div>
  );
};
